import {
  CLEAR_REFERENCE_DATA,
  REFERENCE_DATA_BULK_EDIT_REQUEST,
  REFERENCE_DATA_DELETE_REFERENCE_REQUEST,
  REFERENCE_DATA_HAVE_REQUEST,
  REFERENCE_DATA_TOGGLE_COLUMN,
  REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST,
  REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST,
  REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST,
  REFERENCE_EVENT_DATA_CANCEL_EDIT,
  REFERENCE_EVENT_DATA_EDIT,
  REFERENCE_EVENT_DATA_SAVE_CANCEL_CONFIRMATION,
  REFERENCE_EVENT_DATA_SAVE_OPEN_CONFIRMATION,
  REFERENCE_RUNUP_DATA_CAUSE_REQUEST,
  REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST,
  REFERENCE_RUNUP_DATA_REGION_REQUEST,
  REFERENCE_RUNUP_DATA_VALIDITY_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST,
  REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST,
  REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST,
  REFERENCE_VOLCANO_LOCATION_REGION_REQUEST,
} from './referenceDataReducer';

import { REFERENCE_DATA_SORT } from '../search/referenceSearchReducer';

export const deleteReference = ({ id, history }) => ({ type: REFERENCE_DATA_DELETE_REFERENCE_REQUEST, id, history });
export const clearReferenceData = () => ({ type: CLEAR_REFERENCE_DATA });
export const getHaves = ({ history }) => ({ type: REFERENCE_DATA_HAVE_REQUEST, history });
export const sortData = sort => ({ type: REFERENCE_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: REFERENCE_DATA_TOGGLE_COLUMN, visibleColumns });

export const getEqRegions = ({ history }) => ({ type: REFERENCE_EARTHQUAKE_DATA_REGION_REQUEST, history });

export const getVolRegions = ({ history }) => ({ type: REFERENCE_VOLCANO_EVENT_DATA_REGION_REQUEST, history });

export const getVolLocRegions = ({ history }) => ({ type: REFERENCE_VOLCANO_LOCATION_REGION_REQUEST, history });

export const getTsuValidity = ({ history }) => ({ type: REFERENCE_TSUNAMI_EVENT_DATA_VALIDITY_REQUEST, history });
export const getTsuCauses = ({ history }) => ({ type: REFERENCE_TSUNAMI_EVENT_DATA_CAUSE_REQUEST, history });
export const getTsuRunupMeasurementTypes = ({ history }) => ({ type: REFERENCE_TSUNAMI_EVENT_DATA_RUNUP_MEASURE_TYPE_REQUEST, history });
export const getTsuRegions = ({ history }) => ({ type: REFERENCE_TSUNAMI_EVENT_DATA_REGION_REQUEST, history });

// no deposits?
export const getDepPublicationTypes = ({ history }) => ({ type: REFERENCE_DEPOSIT_DATA_PUBLICATION_TYPES_REQUEST, history });
export const getDepGeologicAges = ({ history }) => ({ type: REFERENCE_DEPOSIT_DATA_GEOLOGIC_AGES_REQUEST, history });

export const getRunupValidity = ({ history }) => ({ type: REFERENCE_RUNUP_DATA_VALIDITY_REQUEST, history });
export const getRunupCauses = ({ history }) => ({ type: REFERENCE_RUNUP_DATA_CAUSE_REQUEST, history });
export const getRunupRunupMeasurementTypes = ({ history }) => ({ type: REFERENCE_RUNUP_DATA_MEASURE_TYPE_REQUEST, history });
export const getRunupRegions = ({ history }) => ({ type: REFERENCE_RUNUP_DATA_REGION_REQUEST, history });

export const bulkEditReferences = ({ data }) => ({ type: REFERENCE_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: REFERENCE_EVENT_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: REFERENCE_EVENT_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: REFERENCE_EVENT_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: REFERENCE_EVENT_DATA_CANCEL_EDIT });
